export default __webpack_public_path__ + "static/media/chevron-down-na.f428ec94.svg";